import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core'

import {
  KeyActionViewModel,
  MAX_SELECTED_KEY_ACTION_COUNT,
  OPERATOR_SCORE_COUNT,
} from './key-action-selector.logic'

@Component({
  selector: 'app-key-action-selector',
  standalone: true,
  templateUrl: './key-action-selector.component.html',
  styleUrl: './key-action-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KeyActionSelectorComponent {
  private keyActionOptions: readonly KeyActionViewModel[] = []
  private selectedIds: string[] = []

  @Input({ required: true })
  set options(options: readonly KeyActionViewModel[]) {
    this.keyActionOptions = options
    this.selectedIds = options
      .filter((option) => option.selected)
      .map(({ id }) => id)
    this.selectedCount = this.selectedIds.length
    this.selectionLimitReached =
      this.selectedCount >= MAX_SELECTED_KEY_ACTION_COUNT
  }

  get options(): readonly KeyActionViewModel[] {
    return this.keyActionOptions
  }

  @Input({ required: true }) description!: string
  @Input({ required: true }) ariaLabel!: string
  @Input() readonly = false

  @Output() readonly selectedIdsChange = new EventEmitter<string[]>()

  readonly maxSelectedKeyActionCount = MAX_SELECTED_KEY_ACTION_COUNT
  readonly scoreCountLabel = `直近${OPERATOR_SCORE_COUNT}回平均`
  selectedCount = 0
  selectionLimitReached = false

  toggle(option: KeyActionViewModel): void {
    if (this.readonly) {
      return
    }

    if (option.selected) {
      this.selectedIdsChange.emit(
        this.selectedIds.filter((id) => id !== option.id),
      )
      return
    }
    if (this.selectionLimitReached) {
      return
    }

    this.selectedIdsChange.emit([...this.selectedIds, option.id])
  }
}
